import { getUid } from "../../vue/helpers/auth-helpers";
import {
  getSubdomain,
  getProductName,
  config,
} from "../../vue/helpers/domain-config";
import {
  getPlayAndWinLink,
  getPlayNowLink,
  getQuizLink,
  getWorldCupQuizLink,
} from "../../utils/quiz";
import { getSelectedLanguage } from "../utils/local-storage.utils";
import { getDomainConfigValue } from "../../utils/domain-config";

AFRAME.registerSystem("navigate-to-scene", {
  transition: function (commands, navigationOptions) {
    this.el.sceneEl.systems["router"].navigate(commands, navigationOptions);
  },
});

AFRAME.registerComponent("navigate-to-scene", {
  schema: { type: "string" },

  events: {
    click: function () {
      this.system.transition(this.data.split("/"));
    },
  },
});

AFRAME.registerComponent("navigate-to-app", {
  schema: { type: "string" },

  events: {
    click: function () {
      if (
        ["play-now", "play-and-win", "quiz", "world-cup-quiz"].includes(
          this.data
        )
      ) {
        const userToken = getUid();
        const subdomain = getSubdomain();
        const productName = config.productName;

        let link = getQuizLink();
        if (this.data === "play-now") {
          link = getPlayNowLink();
        }
        if (this.data === "play-and-win") {
          link = getPlayAndWinLink();
        }
        if (this.data === "world-cup-quiz") {
          link = getWorldCupQuizLink();
        }

        const parameters = {
          uid: userToken,
        };

        if (this.data !== "play-now") {
          parameters.language = getSelectedLanguage();
          parameters.subdomain = subdomain;

          if (!link.includes("/quiz/categories")) {
            parameters.product = productName;
          }
        }
        const searchParameters = new URLSearchParams(parameters);
        window.location.href = `${link}?${searchParameters}`;
      }
    },
  },
});

AFRAME.registerComponent("navigate-to-link", {
  schema: { type: "string" },

  events: {
    click: function () {
      const url = getDomainConfigValue(this.data);
      if (url) {
        window.location.href = url;
      }
    },
  },
});
